import React from 'react';
import styled from 'styled-components';

interface YoutubeEmbedProps {
  videoId: string;
  /** In percentage to be used as padding-top. Defaults to 53.125% */
  aspectRatio?: number;
}

export default function YoutubeEmbed({
  videoId,
  aspectRatio,
}: YoutubeEmbedProps) {
  return (
    <VideoCss aspectRatio={`${aspectRatio ?? 53.125}%`}>
      <IframeCss
        id={videoId}
        width="100%"
        height="100%"
        src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1&modestbranding=1&playsinline=1&rel=0`}
        frameBorder="0"
      ></IframeCss>
    </VideoCss>
  );
}

const VideoCss = styled('div')<{ aspectRatio: string }>`
  position: relative;
  padding-top: ${p => p.aspectRatio};
`;

const IframeCss = styled('iframe')`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
